import React from 'react';
import styles from './Hamburger.module.scss';

const X = () => {
	return <span className={styles.hamburger}>♱</span>;
};
export default X;
